import { GoogleOAuthProvider } from '@react-oauth/google';


const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '959606777883-08hvgcvdoa4pg9bi63eplq5ok30n5rm2.apps.googleusercontent.com' ;

console.log('Google Client ID:', googleClientId);


if (!googleClientId) {
  console.error('❌ Missing REACT_APP_GOOGLE_CLIENT_ID environment variable');
  process.exit(1);
}

const OAuthWrapper = ({ children }) => (
  <GoogleOAuthProvider clientId={googleClientId}>
    {children}
  </GoogleOAuthProvider>
);

export default OAuthWrapper;